// extracted by mini-css-extract-plugin
export default {"button":"LoadingButton_button__t4C6p","icon":"LoadingButton_icon__3zSKH","rotation":"LoadingButton_rotation__I4nk2"};